exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".myFont{font-family:Poppins,sans-serif}.overflow-y-scroll{overflow-y:auto}.my-main{background:#f9f5ff!important}", ""]);

// exports
